
/* injects from baggage-loader */

import React, {useCallback, useState} from "react";

const InfoBlock = (props) => {
    const [state, setState] = useState(false);
    const handleClick = useCallback((e) => { setState(!state); e.stopPropagation(); });
    return (
        <>
            <i className="infoBlock" onClick={handleClick}>
                <i className={state ? "active" : ""}>{props.info}</i>
            </i>
        </>
    );
};

export default InfoBlock;